export default import.meta.ROLLDOWN_FILE_URL_KyyWQwoBf4YRI66TsiB0GQ